export default __webpack_public_path__ + "2f8d6f75f5e659eb827dab73fcb214c8.png";